import initIcons from '@kupibilet/icons'
import { Wrap } from './styled'

const IconsSprite = () => {
  return <Wrap dangerouslySetInnerHTML={{ __html: initIcons() }} />
}

export default IconsSprite
